import { css } from '@emotion/react';

import { rem, hexToRgb } from '../utilities/style';
import { colors } from '../theme/colors';
import { media } from '../theme/media';
import stacking from '../theme/stacking';
import { fonts } from '../theme/type';

import fontStyles from './fonts';
import hubspotStyles from './hubspot';

export default css`
  ${fontStyles}

  html {
    box-sizing: border-box;
  }

  .intercom-namespace {
    position: relative;
    z-index: ${stacking.intercom};
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  body {
    font-family: ${fonts.poppins};
    margin: 0;
  }

  p,
  ol,
  ul,
  li,
  dl,
  dt,
  dd,
  blockquote,
  figure,
  fieldset,
  legend,
  textarea,
  pre,
  iframe,
  hr,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    padding: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 100%;
    font-weight: normal;
    text-wrap: balance;
  }

  p {
    text-wrap: pretty;
  }

  embed,
  iframe,
  img,
  svg,
  object,
  video {
    display: block;
    max-width: 100%;
  }

  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  a {
    text-decoration: none;

    &:focus {
      outline: default;
    }
  }

  ul,
  ol {
    list-style: none;
  }

  .ReactModal__Overlay {
    background: rgba(${hexToRgb(colors.blue['800'])}, 0.5);
    display: flex;
    padding: ${rem(90)} ${rem(20)} ${rem(60)};
    overflow-y: auto;
    transition: opacity .2s ease, visibility .2s ease;
    opacity: 0;
    visibility: hidden;

    ${media('>nav')} {
      padding-top: ${rem(120)};
    }
  }

  .ReactModal__Overlay--after-open {
    opacity: 1;
    visibility: visible;
  }

  div[class*="shadow"] .spz-templete .hero-section .hero-container div.hero-wrapper,
  .ReactModal__Overlay--after-open .spz-templete .hero-section .hero-container div.hero-wrapper, {
    margin-left: 0;
    transform: translateX(0%);
  }

  ${hubspotStyles}

  /* Fix for Justuno bottom bars */
  iframe[id*="_jst-iframe-"][style*="position: sticky; z-index: 2147483647"] {
    z-index: 2147482000 !important;
  }

  .noscroll {
    position: relative;
    overflow: hidden;
    height: 100%;
  }

  /* Conditional header display for intercom */
  html.intercom-mobile-messenger-active header,
  html.intercom-mobile-messenger-active > body header,
  html.intercom-modal-open header,
  #intercom-container-body header {
    display: none;
  }
`;
